import { render, staticRenderFns } from "./OnBoardingCard.vue?vue&type=template&id=30d76c09&"
import script from "./OnBoardingCard.vue?vue&type=script&lang=js&"
export * from "./OnBoardingCard.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports